<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="empleado" titulo="Empleado / Personas" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">

    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- inicio formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>
                <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
                    <br>
                    <span class="tag is-primary is-large ">
                        <span class="icon">
                            <i class="icon-worldwide fa-spin"></i>
                        </span> &nbsp;
                        <span>Cargando...</span>
                    </span>
                </div>

                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">

                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('paises', 'paises'); ctrl.cargarCatalogo('tipos_medios', 'tipo-medio'); ctrl.cargarCatalogo('tipos_redes_sociales', 'tipo-red-social');"></a>
                    <div class="contenedor columns ">
                        <div class="column is-one-quarter is-hidden-mobile menu-persona">
                            <div>
                                <figure class="image is-3by2">
                                    <img *ngIf="!ctrl.subir[0]" [src]="ctrl.API_PATH+'/adjunto/personas/'+ctrl.dato.get('foto').value" alt="Foto" />
                                    <img *ngIf="ctrl.subir[0]" [src]="'data:image/jpg;base64,'+ctrl.dato.get('foto').value" alt="Foto" />
                                </figure>
                                <div align="center">
                                    <strong>{{ctrl.dato.get('nombre').value}}</strong>
                                    <small>{{ctrl.dato.get('email').value}}</small>
                                </div>
                                <hr>
                                <nav class="panel" *ngIf="ctrl.dato.controls.personas_contactos.controls.length > 0">
                                    <p class="panel-heading">
                                        Contactos
                                    </p>
                                    <div class="panel-block" *ngFor="let medio of ctrl.dato.controls.personas_contactos.controls; let suc = index;">
                                        <span class="panel-icon" *ngIf="ctrl.tipos_medios.length > 0">
                                            <i [ngClass]="ctrl.tipos_medios[medio.value.tipos_medios_id - 1].icon"></i>
                                        </span>
                                        {{ medio.value.valor }}
                                    </div>
                                </nav>

                            </div>
                        </div>
                        <div class="column">

                            <div class="tabs is-boxed" style="margin-top: -10px;">

                                <!-- se crea los tab se debe definir una variable llamada tab en el .ts con un valor por default ejemplo tab=1 -->
                                <ul>
                                    <li [ngClass]="{ 'is-active' : tab == 1}">
                                        <a (click)="tab=1">
                                            <span class="icon is-small is-right">
                                                <i class="icon-file"></i>
                                            </span>
                                            <span>General</span>
                                        </a>
                                    </li>

                                    <li [ngClass]="{ 'is-active' : tab == 6}">
                                        <a (click)="tab=6">
                                            <span class="icon is-small is-right">
                                                <i class="icon-padlock"></i>
                                            </span>
                                            <span>Seguridad</span>
                                        </a>
                                    </li>

                                    <li [ngClass]="{ 'is-active' : tab == 2}">
                                        <a (click)="tab=2">
                                            <span class="icon is-small is-right">
                                                <i class="icon-book"></i>
                                            </span>
                                            <span>Medios de contacto</span>
                                        </a>
                                    </li>

                                    <li [ngClass]="{ 'is-active' : tab == 5}">
                                        <a (click)="tab=5">
                                            <span class="icon is-small is-right">
                                                <i class="fa fa-facebook"></i>
                                            </span>
                                            <span>Redes Sociales</span>
                                        </a>
                                    </li>

                                    <li [ngClass]="{ 'is-active' : tab == 3}">
                                        <a (click)="tab=3">
                                            <span class="icon is-small is-right">
                                                <i class="icon-credit-card-2"></i>
                                            </span>
                                            <span>Banco</span>
                                        </a>
                                    </li>
                                    <!--
                                <li [ngClass]="{ 'is-active' : tab == 4}">
                                    <a (click)="tab=4">
                                        <span class="icon is-small is-right"><i class="fa fa-laptop"></i></span>
                                        <span>Apps</span>
                                    </a>
                                </li>
                                -->

                                </ul>
                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 1}">

                                <div class="field">
                                    <label class="label">Nombre:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }" placeholder="nombre"
                                            formControlName="nombre">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                                    </p>
                                </div>

                                <div class="field">
                                    <label class="label">Correo eléctronico:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('email').hasError('required') && ctrl.dato.get('email').hasError('required')}"
                                            placeholder="Correo eléctronico" formControlName="email">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('email').hasError('required') && ctrl.dato.get('email').hasError('required')">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.get('email').hasError('required') && ctrl.dato.get('email').hasError('required')">Este campo es requerido.</span>
                                    </p>
                                </div>

                                <div class="columns">
                                    <div class="column is-4">
                                        <label class="label">País:</label>
                                        <ng-select2 [disabled]="ctrl.paises ? ctrl.paises.length == 0 ? true : false : true" name="paises_id" [options]="ctrl.optionSelect" [value]="paises_id" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.paises_id, 'estados', 'estados'); autovalor_pais();"
                                            [data]="ctrl.paises"></ng-select2>

                                    </div>

                                    <div class="column is-4">
                                        <label class="label">Estado:</label>
                                        <ng-select2 [disabled]="ctrl.estados ? ctrl.estados.length == 0 ? true : false : true" name="estados_id" [options]="ctrl.optionSelect" [value]="estados_id" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.estados_id, 'municipios', 'municipios'); autovalor_estado()"
                                            [data]="ctrl.estados"></ng-select2>
                                    </div>

                                    <div class="column is-4">
                                        <label class="label">Municipio:</label>
                                        <ng-select2 [disabled]="ctrl.municipios ? ctrl.municipios.length == 0 ? true : false : true" name="municipios_id" [options]="ctrl.optionSelect" [value]="municipios_id" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.municipios_id); autovalor_municipio();"
                                            [data]="ctrl.municipios"></ng-select2>
                                    </div>
                                </div>

                                <div class="columns">
                                    <div class="column is-6">
                                        <div class="field">
                                            <label class="label">Direccion:</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="text" placeholder="direccion" formControlName="direccion">
                                            </p>
                                        </div>
                                    </div>

                                    <div class="column is-3">
                                        <div class="field">
                                            <label class="label">Num. Exterior:</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="text" placeholder="Num. Exterior" formControlName="numero_exterior">
                                            </p>
                                        </div>
                                    </div>

                                    <div class="column is-3">
                                        <div class="field">
                                            <label class="label">Num. Interior:</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="text" placeholder="Num. Interior" formControlName="numero_interior">
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns">
                                    <div class="column is-6">
                                        <div class="field">
                                            <label class="label">Col. / Fracc.:</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="text" placeholder="Col. / Fracc." formControlName="colonia">
                                            </p>
                                        </div>
                                    </div>

                                    <div class="column is-3">
                                        <div class="field">
                                            <label class="label">Codigo Postal:</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="text" placeholder="CP" formControlName="codigo_postal">
                                            </p>
                                        </div>
                                    </div>

                                    <div class="column is-3">
                                        <br>
                                        <br>
                                        <div class="field">
                                            <div class="b-checkbox is-info">
                                                <input id="spam" class="styled" type="checkbox" formControlName="spam">
                                                <label for="spam">
                                                    Acepta recibir información por correo?
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns">

                                    <div class="column is-4">
                                        <div class="field">
                                            <label class="label">Ultimo acceso:</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('last_login').hasError('required') && ctrl.dato.get('last_login').hasError('required')}"
                                                    placeholder="Ultimo acceso" formControlName="last_login">
                                            </p>
                                        </div>
                                    </div>

                                    <div class="column is-4">
                                        <br>
                                        <br>
                                        <div class="field">
                                            <div class="b-checkbox is-info">
                                                <input id="activo" class="styled" type="checkbox" formControlName="activo">
                                                <label for="activo">
                                                    Esta activo?
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field">
                                    <label class="label">Avatar:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="text" placeholder="Foto" formControlName="avatar">
                                    </p>
                                </div>

                                <div class="field">
                                    <label class="label">foto:</label>
                                    <div class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.get('foto').value == ''">
                                        <div class="file has-name">
                                            <label class="file-label">
                                                <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.foto)" accept="image/x-png,image/gif,image/jpeg,image/jpg">
                                                <input foto type="hidden" formControlName="foto">
                                                <span class="file-cta">
                                                    <span class="file-icon">
                                                        <i class="fa fa-upload"></i>
                                                    </span>
                                                    <span class="file-label">
                                                        Seleccionar archivo
                                                    </span>
                                                </span>

                                            </label>
                                        </div>
                                    </div>

                                    <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.foto, 'personas')" *ngIf="ctrl.dato.get('foto').value != ''">

                                        <span class="icon ">
                                            <i class="icon-trash"></i>
                                        </span>
                                        &nbsp; Eliminar la foto

                                    </button>

                                </div>

                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 2}">

                                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('personas_contactos').length > 0">
                                    <thead>
                                        <tr>
                                            <th hide-sm>ID</th>
                                            <th>Medio de contacto</th>
                                            <th>Valor</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody formArrayName="personas_contactos">
                                        <tr *ngFor="let medio of ctrl.dato.controls.personas_contactos.controls; let suc=index" [formGroupName]="suc">
                                            <td>{{ suc + 1 }}</td>
                                            <td>
                                                <div class="select">
                                                    <select class="select" name="tipos_medios_id" formControlName="tipos_medios_id">
                                                        <option *ngFor="let val of ctrl.tipos_medios" value="{{val.id}}">{{ val.nombre }}</option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td>
                                                <p class="control has-icon">
                                                    <input class="input" formControlName="valor" placeholder="Valor" [ngClass]="{'is-danger': !ctrl.dato.controls.personas_contactos.controls[suc].controls.valor.valid}"
                                                        type="text">
                                                    <span class="icon is-small is-right">
                                                        <i [ngClass]="ctrl.tipos_medios[ctrl.dato.controls.personas_contactos.controls[suc].controls.tipos_medios_id.value - 1].icon"></i>
                                                    </span>
                                                </p>

                                            </td>
                                            <td align="right">
                                                <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.personas_contactos, suc)">
                                                    <i class="icon-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                                    <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.personas_contactos, form_personas_contactos)">
                                        <i class="icon-add2"></i>
                                    </button>
                                </div>
                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 3}">

                                <div class="field">
                                    <label class="label">Banco:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="text" placeholder="Banco" formControlName="banco">
                                    </p>
                                </div>

                                <div class="field">
                                    <label class="label">Cuenta:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="text" placeholder="Cuenta" formControlName="cuenta_bancaria">
                                    </p>
                                </div>

                                <div class="field">
                                    <label class="label">Clabe:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="text" placeholder="Clabe" formControlName="clabe_interbancaria">
                                    </p>
                                </div>
                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 4}">
                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 5}">
                                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('personas_redes_sociales').length > 0">
                                    <thead>
                                        <tr>
                                            <th hide-sm>ID</th>
                                            <th>Red</th>
                                            <th>Valor</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody formArrayName="personas_redes_sociales">
                                        <tr *ngFor="let medio of ctrl.dato.controls.personas_redes_sociales.controls; let suc=index" [formGroupName]="suc">
                                            <td>{{ suc + 1 }}</td>
                                            <td>
                                                <div class="select">
                                                    <select class="select" name="tipos_redes_sociales_id" formControlName="tipos_redes_sociales_id">
                                                        <option *ngFor="let val of ctrl.tipos_redes_sociales" value="{{val.id}}">{{ val.nombre }}</option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td>
                                                <p class="control has-icon">
                                                    <input class="input" formControlName="valor" placeholder="Valor" [ngClass]="{'is-danger': !ctrl.dato.controls.personas_redes_sociales.controls[suc].controls.valor.valid}"
                                                        type="text">
                                                    <span class="icon is-small is-right">
                                                        <i [ngClass]="ctrl.tipos_redes_sociales[ctrl.dato.controls.personas_redes_sociales.controls[suc].controls.tipos_redes_sociales_id.value - 1].icon"></i>
                                                    </span>
                                                </p>

                                            </td>
                                            <td align="right">
                                                <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.personas_redes_sociales, suc)">
                                                    <i class="icon-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                                    <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.personas_redes_sociales, form_personas_redes_sociales)">
                                        <i class="icon-add2"></i>
                                    </button>
                                </div>
                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 6}">

                                <br>
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="cambiarPassword" class="styled" type="checkbox" formControlName="cambiarPassword" (click)="toggleCambiarPassword()">
                                        <label for="cambiarPassword">
                                            Cambiar contraseña
                                        </label>
                                    </div>
                                </div>
                                <hr>

                                <div class="field">
                                    <label class="label">Usuario:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="text" placeholder="Usuario" formControlName="username">
                                    </p>
                                </div>

                                <div class="field">
                                    <label class="label">Contraseña:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="text" placeholder="Contraseña" formControlName="password">
                                    </p>
                                </div>

                                <div class="field">
                                    <label class="label">Repetir Contraseña:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="text" placeholder="Repetir Contraseña" formControlName="confirmarPassword">
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- fin formulario -->
                </section>


            </form>
        </div>
    </div>
</div>
